import '../TableCard/card.css'
import React from "react"
import {Col, Row} from 'react-bootstrap';
import CustomCardList from "../../List/CustomCardList";
import TableCard from "../TableCard/TableCard";

function CustomCardGrid({metadata, endpoint}) {


  const renderItems = (data) => {
    return <Row key={data && data.id}>
      {data && <Col sm={3}>
        <TableCard metadata={metadata} endpoint={endpoint} data={data} />
      </Col>
      }
      </Row>
    }
  return <CustomCardList
    sortParam={"createdAt,DESC"}
    display={styles.display}
    flatListStyle={styles.flatListStyle}
    button={true}
    endpoint={endpoint}
    renderItems={renderItems}
  />

}

export default CustomCardGrid;
const styles = {
  flatListStyle: {
    marginRight: "100px",
    position: "relative",
    paddingBottom: "65px",
    rowGap: "10px"
  },
  display: {
    grid: true,
    minColumnWidth: "100px",
    gridGap: "160px",
  },
}



// WEBPACK FOOTER //
// ./src/component/Card/customCardGrid/CustomCardGrid.js